import { useEffect, useState } from 'react'
import { getReportAttendanceDropStaffAPI } from '../../../services/report/attendanceSum'

const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== '' && v !== null && v !== undefined
    )
  )

function UseReportAttendanceDropStaff(orgId, search, language = 'en') {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let ignore = false

    if (!orgId || !search) {
      setOptions([])
      setRawData([])
      setLoading(false)
      return
    }

    const getData = async () => {
      setLoading(true)
      const headers = language ? { 'Accept-Language': language } : {}
      const resp = await getReportAttendanceDropStaffAPI(
        cleanParams({ orgId, search }),
        headers
      )

      if (ignore) return

      setLoading(false)
      if (!resp) return
      if (resp.status) {
        setRawData(resp.result)
        const newData = resp.result.map((d) => ({
          value: d?.code,
          label: `${d?.code}-${d?.fullname} (${d?.nickname})`,
          key: d?.code
        }))
        setOptions(newData)
      } else {
        setOptions([])
        setRawData([])
      }
    }

    getData()

    return () => {
      ignore = true
    }
  }, [orgId, search, language])

  return { options, rawData, loading }
}

export default UseReportAttendanceDropStaff
